import Head from 'next/head';

type TitleHeadProps = {
  title: string;
};

export const TitleHead = (props: TitleHeadProps) => {
  const { title } = props;

  return (
    <Head>
      <title>{title} - PFN 3D Scan</title>
    </Head>
  );
};

export default TitleHead;
